import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const createUserData = createAsyncThunk('createUser/createUserData', async (values) => {
  try {
    const response = await axios.post(`GetADDetails/createUser`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
export const importUser = createAsyncThunk('GetADDetails/ImportUsers', async (values) => {
  try {
    const response = await axios.post(`/GetADDetails/ImportUsers?fqdn=${values.fqdn}`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { error: err.message };
  }
});
//Geting Single User For Edit (Admin)
export const getOneUser = createAsyncThunk('User/getOneUser', async (value) => {
  const response = await axios.get(
    `GetADDetails/getSingleUser?userName=${encodeURIComponent(value.userName)}&FQDN=${value.fqdn}&domainId=${
      value.domainId
    }`
  );
  return { status: response.status, data: response.data };
});

//Creating Bulk Users
export const bulkUserCreate = createAsyncThunk('createUser/bulkUserCreate', async (values) => {
  try {
    const response = await axios.post(`GetADDetails/bulkcreateusers`, values);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const createUser = createSlice({
  name: 'createUserData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(createUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default createUser.reducer;
